import cx from 'classnames'
import { ReactNode, FC, memo, useEffect, useRef, useState } from 'react'
import { Icon } from '@/components/ui'
import { useDebounce } from '@/hooks/useDebounce'
import { useWindowSize } from '@/hooks/useWindowSize'
import s from './style.module.scss'

interface IPanelFaq {
  children: ReactNode
  label: string
  isActive: boolean
  setIsActive: (isActive: boolean) => void
  disabled?: boolean
  // options?: ReactNode
  isArrowMoving?: boolean
  icon?: string
  // searchedText?: string
  className?: string
}

export const Panel: FC<IPanelFaq> = memo(
  ({ children, label, isActive, setIsActive, disabled, isArrowMoving = true, icon = '', className }: IPanelFaq) => {
    const { width } = useWindowSize()
    const debouncedWidth = useDebounce(width, 500)
    const [height, setHeight] = useState(0)
    const panelRef = useRef(null)
    const contentRef = useRef<null | HTMLDivElement>(null)

    useEffect(() => {
      const height = contentRef?.current?.lastElementChild?.clientHeight
      setHeight(height ?? 0)
    }, [isActive, debouncedWidth])

    const panelClassList = cx(
      s.panel,
      {
        [s.active]: isActive,
        [s['arrow-moving']]: isArrowMoving
      },
      className
    )

    const inners = {
      height: `${isActive ? height : 0}px`
    }

    return (
      <div ref={panelRef} className={panelClassList}>
        <button className={s.panel__label} onClick={() => setIsActive(!isActive)} disabled={disabled}>
          {label}
          <Icon className={s.arrow} name={icon || (isArrowMoving ? 'arrow-up' : 'arrow-down')} size='xs' />
        </button>

        <div ref={contentRef} className={s.panel__inner} style={inners}>
          <div className={s.panel__content}>{children}</div>
        </div>
      </div>
    )
  }
)
